import { createAction } from 'redux-actions';

export const loadAllResults = createAction('LOAD_ALL_RESULTS');
export const loadDocumentResults = createAction('LOAD_DOCUMENT_RESULTS');
export const paginateClients = createAction('PAGINATE_CLIENTS');
export const paginateFolders = createAction('PAGINATE_FOLDERS');
export const paginateDocumentations = createAction('PAGINATE_DOCUMENTATIONS');
export const paginateNotifications = createAction('PAGINATE_NOTIFICATIONS');
export const paginateContacts = createAction('PAGINATE_CONTACTS');
export const searchClients = createAction('SEARCH_CLIENTS');
export const searchDocumentation = createAction('SEARCH_DOCUMENTATION');
export const searchFolders = createAction('SEARCH_FOLDERS');
export const searchNotificationResults = createAction('SEARCH_NOTIFICATION_RESULTS');
export const searchResultContacts = createAction('SEARCH_RESULT_CONTACTS');
export const loadDocument = createAction('LOAD_DOCUMENT');
export const setAllClientData = createAction('SET_ALL_CLIENT_DATA');
export const setShowStateFilter = createAction('SET_SHOW_STATE_FILTER');
export const setClientsCount = createAction('SET_CLIENTS_COUNT');
export const setContactsCount = createAction('SET_CONTACTS_COUNT');
export const setFoldersCount = createAction('SET_FOLDERS_COUNT');
export const setDocumentsCount = createAction('SET_DOCUMENTS_COUNT');
export const setCommunicationsCount = createAction('SET_COMMUNICATIONS_COUNT');
export const setMassiveCommunicationsCount = createAction('SET_MASSIVE_COMMUNICATIONS_COUNT');
export const setGeneralSearchText = createAction('SET_GENERAL_SEARCH_TEXT');
